import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { pluralize } from '../../../helpers/string';

/**
 * @description Render memoized order total component
 * @param {Object} props
 * @returns {JSX.Element} Memoized order total component
 */
export const OrderTotal = memo(function MemoizedOrderTotal(props) {
  const { cartTotal = 0, cartNum = 0, onClose, goCheckout, loading } = props;

  return (
    <div className="w-full text-center">
      <p className="text-sm font-normal text-gray-500">Order subtotal</p>
      <p className="mt-4 text-xl font-normal text-black">
        ${cartTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}
      </p>
      <p className="mt-4 text-sm font-normal text-gray-500">{`Your cart contains ${pluralize(cartNum, 'item')}`}</p>
      <div className="mt-10 flex flex-col items-center justify-center">
        <button
          disabled={loading}
          className={`color-white w-full border border-black bg-black py-3 text-sm text-white ${
            loading ? 'cursor-not-allowed bg-gray-500' : ''
          }`}
          onClick={goCheckout}
        >
          Proceed to checkout
        </button>
        <button className="mt-4 w-full border border-black px-2 py-3 text-sm text-black" onClick={onClose}>
          Continue Shopping
        </button>
        <Link className="mt-4 w-full py-3 text-sm text-black" to="/cart">
          View or Edit Cart
        </Link>
      </div>
    </div>
  );
});

OrderTotal.propTypes = {
  cartNum: PropTypes.number,
  cartTotal: PropTypes.number,
  goCheckout: PropTypes.func,
  onClose: PropTypes.func
};
